import { render } from "./ChatBotComponent.vue?vue&type=template&id=9553edf2"
import script from "./ChatBotComponent.vue?vue&type=script&lang=js"
export * from "./ChatBotComponent.vue?vue&type=script&lang=js"

import "./ChatBotComponent.vue?vue&type=style&index=0&id=9553edf2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__